import { Box, CircularProgress } from '@mui/material'
import { useProfileRole } from '../hooks/useProfileRole'
import { AthleteProfileView } from '../components/profile/athlete/AthleteProfileView'
import { RecruiterProfileView } from '../components/profile/recruiter/RecruiterProfileView'
import { EmptyStatePanel } from '../components/StatePanel'

/** Read-only view of the current user's own profile. */
export const ProfilePage = () => {
  const { isLoading, isStudent, isRecruiter } = useProfileRole()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    )
  }

  if (isStudent) return <AthleteProfileView />
  if (isRecruiter) return <RecruiterProfileView />

  return (
    <EmptyStatePanel
      title="Profile unavailable"
      description="We couldn't determine your account type. Try refreshing, or contact support if this continues."
    />
  )
}
